import { useFormik } from 'formik';
import { FormGroup } from 'shared-components';
import * as yup from 'yup';
import { Button } from 'shared-components';
import { toast } from 'react-toastify';
import { close } from '../modal/modalSlice';
import { useAppDispatch } from '../../app/hooks';
import { useCreateCouponMutation } from './coupons.api';

export const CouponCreateForm = () => {
  const dispatch = useAppDispatch();
  const [createCoupon] = useCreateCouponMutation();
  const { getFieldProps, handleSubmit } = useFormik<{
    code: string;
  }>({
    initialValues: {
      code: '',
    },
    validationSchema: yup.object({
      code: yup.string().required().min(3),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        await createCoupon({
          ...values,
        }).unwrap();

        toast.success('Coupon created!');
        dispatch(close());
      } catch (e) {
        toast.error('Error creating coupon');
      }
    },
  });

  return (
    <form onSubmit={handleSubmit}>
      <FormGroup>
        <label htmlFor="code">Code</label>
        <input {...getFieldProps('code')} type="text" id="name" />
      </FormGroup>
      <FormGroup>
        <Button type="submit">Create</Button>
      </FormGroup>
    </form>
  );
};
